export const connectedToDisconnected = 'CONNECTED_TO_DISCONNECTED';
export const connectedToOther = 'CONNECTED_TO_OTHER';
export const disconnectedToConnected = 'DISCONNECTED_TO_CONNECTED';
